const mockReply = {
  "charts": [{
    "charts": [{
      "type": "line-chart",
      "title": "Приклад area-chart",
      "subtitle": {
        "type": "insight",
        "delta": "9%",
        "trend": "up",
        "text": "у порівнянні з попереднім місяцем"
      },
      "primaryValue": 245,
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Set 1",
          "details": "Details",
          "maxPointPrecision": "month",
          "fillStyle": {
            "stops": [{
              "color": "rgba(41, 165, 255, 0.6)",
              "position": 0
            }, {
              "color": "rgba(41, 165, 255, 0)",
              "position": 1
            }]
          },
          "lineStyle": "#29A5FF",
          "points": [{
            "y": 70,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 65,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 55,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 75,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 73,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 73,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }]
      }
    }, {
      "type": "line-chart",
      "title": "Приклад line-chart",
      "subtitle": {
        "type": "insight",
        "delta": "20%",
        "trend": "down",
        "text": "у порівнянні з попереднім місяцем"
      },
      "primaryValue": 53,
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Set 1",
          "details": "Details",
          "lineStyle": "#19DE92",
          "points": [{
            "y": 70,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 65,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 55,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 75,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 73,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 73,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }]
      }
    }]
  }, {
    charts: [{
      "title": "Певне числове значення",
      "primaryValue": 630596,
      "subtitle": {
        "type": "insight",
        "delta": "9%",
        "trend": "up",
        "text": ""
      }
    }, {
      "title": "Певне числове значення",
      "primaryValue": 13053,
      "subtitle": {
        "type": "insight",
        "delta": "20%",
        "trend": "down",
        "text": ""
      }
    }, {
      "title": "Певне числове значення",
      "primaryValue": 979,
      "subtitle": {
        "type": "insight",
        "delta": "18%",
        "trend": "up",
        "text": ""
      }
    }]
  }, {
    charts: [{
      "type": "line-chart",
      "title": "Приклад area-chart з розподілом",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Set 1",
          "details": "Details",
          "fillStyle": "#19DE92",
          "points": [{
            "y": 70,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 65,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 55,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 75,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 73,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 73,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }, {
          "label": "Set 2",
          "details": "Details",
          "fillStyle": "#FFDE65",
          "points": [{
            "y": 30,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 35,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 25,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 27,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 30,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 26,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 25,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 30,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }, {
          "label": "Set 3",
          "details": "Details",
          "fillStyle": "#42B0FF",
          "points": [{
            "y": 20,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 15,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 15,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 7,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 20,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 6,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 15,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 10,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }]
      }
    }, {
      "type": "line-chart",
      "title": "Приклад line-chart з розподілом",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Set 1",
          "details": "Details",
          "lineStyle": "#19DE92",
          "points": [{
            "y": 70,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 65,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 55,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 75,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 73,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 73,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }, {
          "label": "Set 2",
          "details": "Details",
          "lineStyle": "#FFDE65",
          "points": [{
            "y": 30,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 35,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 25,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 27,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 30,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 26,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 25,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 30,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }, {
          "label": "Set 3",
          "details": "Details",
          "lineStyle": "#42B0FF",
          "points": [{
            "y": 20,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 15,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 15,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 7,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 20,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 6,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 15,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 10,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }]
      }
    }]
  }, {
    charts: [{
      "type": "line-chart",
      "title": "Приклад area-chart",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Set 1",
          "details": "Details",
          "fillStyle": "#19DE92",
          "points": [{
            "y": 70,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 65,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 55,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 60,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 75,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 73,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 73,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }, {
          "label": "Set 2",
          "details": "Details",
          "fillStyle": "#FFDE65",
          "points": [{
            "y": 30,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 35,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 25,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 27,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 30,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 26,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 25,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 30,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }, {
          "label": "Set 3",
          "details": "Details",
          "fillStyle": "#42B0FF",
          "points": [{
            "y": 20,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 15,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 15,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 7,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 20,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 6,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 15,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 10,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }]
      }
    }]
  }, {
    charts: [{
      "type": "pie-chart",
      "title": "Приклад pie-chart",
      "data": {
        "sets": [{
          "label": "Set 1",
          "value": 48,
          "color": "#19DE92"
        }, {
          "label": "Set 2",
          "value": 12,
          "color": "#5245DF"
        }, {
          "label": "Set 3",
          "value": 12,
          "color": "#FFDE65"
        }, {
          "label": "Set 4",
          "value": 5,
          "color": "#42B0FF"
        }]
      }
    }, {
      "type": "circular-progress-chart",
      "title": "Приклад circle progress-chart",
      "data": {
        "sets": [{
          "label": "Set 1",
          "value": 90,
          "details": "Details",
          "color": "#42B0FF"
        }, {
          "label": "Set 2",
          "value": 84,
          "details": "Details",
          "color": "#FFDE65"
        }, {
          "label": "Set 3",
          "value": 72,
          "details": "Details",
          "color": "#5245DF"
        }, {
          "label": "Set 3",
          "value": 59,
          "details": "Details",
          "color": "#19DE92"
        }]
      }
    }]
  }, {
    charts: [{
      "type": "progress-chart",
      "title": "Приклад progress-chart",
      "data": {
        "sets": [{
          "value": 83,
          "details": "Додатковий опис з можливим поточненням якихось деталей",
          "color": "linear-gradient(90deg, #0D784F 0%, #19DE92 100%)"
        }]
      }
    }, {
      "type": "progress-chart",
      "title": "Приклад progress-chart",
      "data": {
        "sets": [{
          "value": 48,
          "details": "Додатковий опис з можливим поточненням якихось деталей",
          "color": "linear-gradient(90deg, #286A99 0%, #42B0FF 100%)"
        }]
      }
    }]
  }, {
    charts: [{
      "type": "progress-chart",
      "title": "Приклад progress-chart list",
      "data": {
        "sets": [{
          "label": "Назва значення",
          "value": 59,
          "color": "linear-gradient(90deg, #0D784F 0%, #19DE92 100%)"
        }, {
          "label": "Назва значення",
          "value": 32,
          "color": "linear-gradient(90deg, #286A99 0%, #42B0FF 100%)"
        }, {
          "label": "Назва значення",
          "value": 12,
          "color": "linear-gradient(90deg, #99853D 0%, #FFDE65 100%)"
        }, {
          "label": "Назва значення",
          "value": 80,
          "color": "linear-gradient(90deg, #2D2679 0%, #5245DF 100%)"
        }]
      }
    }]
  }, {
    charts: [{
      "type": "waterfall-chart",
      "title": "Приклад waterfall-chart",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": {
          "green": {
            "label": "Set 1",
            "value": 48,
            "color": "#E75656"
          },
          "red": {
            "label": "Set 2",
            "value": 12,
            "color": "#19DE92"
          }
        },
        "points": [{
          "x": "2023-01-01",
          "set": "red",
          "bandTop": 58,
          "valueTop": 54,
          "valueBottom": 47,
          "bandBottom": 45
        }, {
          "x": "2023-01-10",
          "set": "green",
          "bandTop": 62,
          "valueTop": 59,
          "valueBottom": 52,
          "bandBottom": 50
        }, {
          "x": "2023-01-20",
          "set": "red",
          "bandTop": 66,
          "valueTop": 63,
          "valueBottom": 59,
          "bandBottom": 57
        }, {
          "x": "2023-02-01",
          "set": "green",
          "bandTop": 71,
          "valueTop": 68,
          "valueBottom": 61,
          "bandBottom": 59
        }, {
          "x": "2023-02-10",
          "set": "red",
          "bandTop": 76,
          "valueTop": 73,
          "valueBottom": 68,
          "bandBottom": 66
        }, {
          "x": "2023-02-20",
          "set": "green",
          "bandTop": 81,
          "valueTop": 78,
          "valueBottom": 72,
          "bandBottom": 70
        }, {
          "x": "2023-03-01",
          "set": "red",
          "bandTop": 85,
          "valueTop": 82,
          "valueBottom": 77,
          "bandBottom": 75
        }, {
          "x": "2023-03-10",
          "set": "green",
          "bandTop": 90,
          "valueTop": 87,
          "valueBottom": 81,
          "bandBottom": 79
        }, {
          "x": "2023-03-20",
          "set": "red",
          "bandTop": 95,
          "valueTop": 92,
          "valueBottom": 87,
          "bandBottom": 85
        }, {
          "x": "2023-04-01",
          "set": "green",
          "bandTop": 100,
          "valueTop": 97,
          "valueBottom": 92,
          "bandBottom": 90
        }, {
          "x": "2023-04-10",
          "set": "red",
          "bandTop": 95,
          "valueTop": 92,
          "valueBottom": 87,
          "bandBottom": 85
        }, {
          "x": "2023-04-20",
          "set": "green",
          "bandTop": 90,
          "valueTop": 87,
          "valueBottom": 83,
          "bandBottom": 81
        }, {
          "x": "2023-05-01",
          "set": "red",
          "bandTop": 85,
          "valueTop": 82,
          "valueBottom": 77,
          "bandBottom": 75
        }, {
          "x": "2023-05-10",
          "set": "green",
          "bandTop": 81,
          "valueTop": 78,
          "valueBottom": 73,
          "bandBottom": 71
        }, {
          "x": "2023-05-20",
          "set": "red",
          "bandTop": 76,
          "valueTop": 73,
          "valueBottom": 68,
          "bandBottom": 66
        }, {
          "x": "2023-06-01",
          "set": "green",
          "bandTop": 71,
          "valueTop": 68,
          "valueBottom": 63,
          "bandBottom": 61
        }, {
          "x": "2023-06-10",
          "set": "red",
          "bandTop": 66,
          "valueTop": 63,
          "valueBottom": 59,
          "bandBottom": 57
        }, {
          "x": "2023-06-20",
          "set": "green",
          "bandTop": 62,
          "valueTop": 59,
          "valueBottom": 55,
          "bandBottom": 53
        }, {
          "x": "2023-07-01",
          "set": "red",
          "bandTop": 58,
          "valueTop": 55,
          "valueBottom": 50,
          "bandBottom": 48
        }, {
          "x": "2023-07-10",
          "set": "green",
          "bandTop": 55,
          "valueTop": 52,
          "valueBottom": 47,
          "bandBottom": 45
        }]
      }
    }, {
      "type": "line-chart",
      "title": "combo-chart [DEV]",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Set 1",
          "details": "Details",
          "lineStyle": "#FFDE65",
          "points": [{
            "y": 30,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }, {
            "y": 35,
            "x": "2023-02-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 25,
            "x": "2023-03-01",
            "delta": "30%",
            "trend": "up"
          }, {
            "y": 27,
            "x": "2023-04-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 30,
            "x": "2023-05-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 26,
            "x": "2023-06-01",
            "delta": "10%",
            "trend": "down"
          }, {
            "y": 25,
            "x": "2023-07-01",
            "delta": "50%",
            "trend": "up"
          }, {
            "y": 30,
            "x": "2023-08-01",
            "delta": "10%",
            "trend": "down"
          }]
        }]
      }
    }]
  }, {
    charts: [{
      "type": "flow-chart",
      "title": "Перша інстанція",
      "data": {
        "nodes": [{
          "label": "Кількість справ зі звільненням від відповідальності",
          "id": "DSA5",
          "color": "#E75656",
          "value": 502,
          "column": 0
        }, {
          "label": "Кількість справ із затвердженням угоди",
          "id": "DSA6",
          "color": "#AB68AA",
          "value": 26461,
          "column": 0
        }, {
          "label": "Кількість справ в процесі розгляду",
          "id": "DSA6bis",
          "color": "#BAAC5B",
          "value": 72336,
          "column": 0
        }, {
          "label": "Кількість справ по яким видано обвинувачення та передано матеріали до суду",
          "id": "DSA1",
          "color": "#42B0FF",
          "value": 194623,
          "column": 1
        }, {
          "label": "Кількість справ з відмовою від підтримки обвинувачення у судовому розгляді",
          "id": "DSA2",
          "color": "#FFDE65",
          "value": 342,
          "column": 2
        }, {
          "label": "Кількість справ з винесеним обвинувальним вироком",
          "id": "DSA3",
          "color": "#1BDE93",
          "value": 93001,
          "column": 2
        }, {
          "label": "Кількість справ з винесеним виправдальним вироком",
          "id": "DSA4",
          "color": "#F89678",
          "value": 1981,
          "column": 2
        }, {
          "label": "Всього винесено вироків",
          "id": "DSA10",
          "color": "#5245DF",
          "value": 94982,
          "column": 3
        }, {
          "label": "Кількість справ, де рішення набрало законної сили",
          "id": "DSA8",
          "color": "#42B0FF",
          "value": 147250,
          "column": 4
        }, {
          "label": "Кількість справ, де рішення оскаржено в апеляції",
          "id": "DSA9",
          "color": "#FFDE65",
          "value": -52268,
          "column": 4
        }],
        "links": [{
          "from": "DSA6",
          "to": "DSA1",
          "flow": 26461
        }, {
          "from": "DSA6bis",
          "to": "DSA1",
          "flow": 72336
        }, {
          "from": "DSA5",
          "to": "DSA1",
          "flow": 502
        }, {
          "from": "DSA1",
          "to": "DSA2",
          "flow": 342
        }, {
          "from": "DSA1",
          "to": "DSA3",
          "flow": 93001
        }, {
          "from": "DSA1",
          "to": "DSA4",
          "flow": 1981
        }, {
          "from": "DSA3",
          "to": "DSA10",
          "flow": 93001
        }, {
          "from": "DSA4",
          "to": "DSA10",
          "flow": 1981
        }, {
          "from": "DSA10",
          "to": "DSA8",
          "flow": 94982
        }, {
          "from": "DSA10",
          "to": "DSA9",
          "flow": 52268
        }]
      }
    }]
  }, {
    charts: [{
      "type": "ukraine-map",
      "title": "Кількість справ за обласними прокуратурами",
      "data": {
        "baseColor": "#42B0FF",
        "sets": [{
          "id": "primary",
          "label": "Офіс Генерального прокурора",
          "value": 98,
          "color": "#FFDE65",
          "ignoreForMaxValue": true
        }, {
          "id": "kyiv",
          "label": "Київська міська прокуратура",
          "value": 11
        }, {
          "id": "odesa-oblast",
          "label": "Одеська обласна прокуратура",
          "value": 8
        }, {
          "id": "kyiv-oblast",
          "label": "Київська обласна прокуратура",
          "value": 6
        }, {
          "id": "lviv-oblast",
          "label": "Львівська обласна прокуратура",
          "value": 5
        }, {
          "id": "dnipropetrovsk-oblast",
          "label": "Дніпропетровська обласна прокуратура",
          "value": 4
        }, {
          "id": "zhytomyr-oblast",
          "label": "Житомирська обласна прокуратура",
          "value": 4
        }, {
          "id": "mykolaiv-oblast",
          "label": "Миколаївська обласна прокуратура",
          "value": 4
        }, {
          "id": "kharkiv-oblast",
          "label": "Харківська обласна прокуратура",
          "value": 4
        }, {
          "id": "cherkasy-oblast",
          "label": "Черкаська обласна прокуратура",
          "value": 4
        }, {
          "id": "chernivtsi-oblast",
          "label": "Чернівецька обласна прокуратура",
          "value": 4
        }, {
          "id": "vinnytsia-oblast",
          "label": "Вінницька обласна прокуратура",
          "value": 3
        }, {
          "id": "volyn-oblast",
          "label": "Волинська обласна прокуратура",
          "value": 3
        }, {
          "id": "donetsk-oblast",
          "label": "Донецька обласна прокуратура",
          "value": 3
        }, {
          "id": "zakarpattia-oblast",
          "label": "Закарпатська обласна прокуратура",
          "value": 3
        }, {
          "id": "zaporizhzhia-oblast",
          "label": "Запорізька обласна прокуратура",
          "value": 3
        }, {
          "id": "kirovohrad-oblast",
          "label": "Кіровоградська обласна прокуратура",
          "value": 3
        }, {
          "id": "poltava-oblast",
          "label": "Полтавська обласна прокуратура",
          "value": 3
        }, {
          "id": "sumy-oblast",
          "label": "Сумська обласна прокуратура",
          "value": 2
        }, {
          "id": "ternopil-oblast",
          "label": "Тернопільська обласна прокуратура",
          "value": 1
        }]
      }
    }]
  }, {
    charts: [{
      type: "line-chart",
      title: "Приклад списку індикаторів",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Транспортні засоби та техніка",
          "details": "Details",
          "fillStyle": "#19DE92",
          "points": [{
            "y": 1,
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }]
        }, {
          "label": "Обладнання",
          "details": "Details",
          "fillStyle": "#FFDE65",
          "points": [{
            "y": 2,
            "x": "2023-01-01",
            "delta": "5%",
            "trend": "down"
          }]
        }, {
          "label": "Комп'ютерна техніка та електронні пристрої",
          "details": "Details",
          "fillStyle": "#42B0FF",
          "points": [{
            "y": 30,
            "x": "2023-01-01",
            "delta": "34%",
            "trend": "up"
          }]
        }]
      }
    }, {
      type: "line-chart",
      title: "Приклад списку індикаторів 2",
      "data": {
        "minY": 0,
        "maxY": 100,
        "sets": [{
          "label": "Гривні",
          "details": "Details",
          "fillStyle": "#19DE92",
          "points": [{
            "y": 1571610,
            "yFormatted": "1 571 610 ₴",
            "x": "2023-01-01",
            "delta": "20%",
            "trend": "up"
          }]
        }, {
          "label": "Долари США",
          "details": "Details",
          "fillStyle": "#FFDE65",
          "points": [{
            "y": 322075,
            "yFormatted": "322 075 $",
            "x": "2023-01-01",
            "delta": "5%",
            "trend": "down"
          }]
        }, {
          "label": "Євро",
          "details": "Details",
          "fillStyle": "#42B0FF",
          "points": [{
            "y": 316115,
            "yFormatted": "316 115 €",
            "x": "2023-01-01",
            "delta": "34%",
            "trend": "up"
          }]
        }]
      }
    }]
  }, {
    charts: [{
      "type": "ukraine-map",
      "title": "Розподіл справ по областях",
      "data": {
        "baseColor": "#19DE92",
        "sets": [{
          "id": "kyiv-union",
          "label": "Київ та Київська область",
          "value": 1250,
          "valueFormatted": "1 250 справ"
        }, {
          "id": "lviv-oblast",
          "label": "Львівська область",
          "value": 450
        }, {
          "id": "kharkiv-oblast",
          "label": "Харківська область",
          "value": 380
        }, {
          "id": "odesa-oblast",
          "label": "Одеська область",
          "value": 320
        }, {
          "id": "dnipropetrovsk-oblast",
          "label": "Дніпропетровська область",
          "value": 290
        }, {
          "id": "donetsk-oblast",
          "label": "Донецька область",
          "value": 180,
          "color": "#E75656"
        }, {
          "id": "zaporizhzhia-oblast",
          "label": "Запорізька область",
          "value": 150
        }, {
          "id": "poltava-oblast",
          "label": "Полтавська область",
          "value": 120
        }, {
          "id": "vinnytsia-oblast",
          "label": "Вінницька область",
          "value": 95
        }, {
          "id": "cherkasy-oblast",
          "label": "Черкаська область",
          "value": 85
        }, {
          "id": "zhytomyr-oblast",
          "label": "Житомирська область",
          "value": 75
        }, {
          "id": "sumy-oblast",
          "label": "Сумська область",
          "value": 65
        }, {
          "id": "chernihiv-oblast",
          "label": "Чернігівська область",
          "value": 60
        }, {
          "id": "rivne-oblast",
          "label": "Рівненська область",
          "value": 55
        }, {
          "id": "volyn-oblast",
          "label": "Волинська область",
          "value": 50
        }, {
          "id": "ternopil-oblast",
          "label": "Тернопільська область",
          "value": 45
        }, {
          "id": "ivano-frankivsk-oblast",
          "label": "Івано-Франківська область",
          "value": 40
        }, {
          "id": "khmelnytskyi-oblast",
          "label": "Хмельницька область",
          "value": 38
        }, {
          "id": "chernivtsi-oblast",
          "label": "Чернівецька область",
          "value": 35
        }, {
          "id": "zakarpattia-oblast",
          "label": "Закарпатська область",
          "value": 30
        }, {
          "id": "kirovohrad-oblast",
          "label": "Кіровоградська область",
          "value": 28
        }, {
          "id": "mykolaiv-oblast",
          "label": "Миколаївська область",
          "value": 25
        }, {
          "id": "kherson-oblast",
          "label": "Херсонська область",
          "value": 20,
          "color": "#E75656"
        }, {
          "id": "luhansk-oblast",
          "label": "Луганська область",
          "value": 15,
          "color": "#E75656"
        }, {
          "id": "crimea-union",
          "label": "АР Крим",
          "value": 5,
          "color": "#949494",
          "opacity": 0.3
        }]
      }
    }]
  }]
};
export { mockReply };
/*
const mod = {
    charts: json.charts.map((chart) => {
    return {
        charts: [
            chart
        ]
    }
})
};

export { mod as mockReply }; */